import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class PotentialUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Potential'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: PotentialUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): PotentialUnitConverter {
    if (!PotentialUnitConverter.instance) {
      PotentialUnitConverter.instance = new PotentialUnitConverter();
    }
    return PotentialUnitConverter.instance;
  }

  protected units = ['millivolt (mV)', 'volt (V)'] as const;

  protected unitToBase = {
    'millivolt (mV)': 0.001,
    'volt (V)': 1,
  };
}
